export const lightGreen = "#85f49c";
export const darkGreen = "#187326";
export const red = "#DC3545";
